<template>
  <div style="margin-top: 86px; background-color: #d9d9d9;">
    <div style="margin-top: 30px;" >
      <div>
        <div class="news-body">
          <div class="news-top-right">
            <el-pagination
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="prev, next, ->, slot"
                    small
                    :page-size="size"
                    :total="total">
            </el-pagination>
<!--            <i class="el-icon-arrow-left news-top-button" ></i>-->
<!--            <i class="el-icon-arrow-right news-top-button"></i>-->
          </div>
          <div v-for="item in newsList" :key="item.newsId" class="news-grid">
            <div class="news-left">
              <img class="news-img" :src="item.imgUrl" />
            </div>
            <div class="news-content">
              <div class="news-head">
                {{item.newsUpdateTime}}
              </div>
              <router-link :to="'/news/' + item.newsId">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div class="news-title">
                    {{item.newsTitle}}
                  </div>
                </el-tooltip>
              </router-link>
              <div>
                <span class="news-detail">
                  {{item.newsBrief}}
                </span>
              </div>
              <hr class="news-hr">
              <div class="news-bottom">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {

    name: 'News',
    data() {
      return {
        newsList: [],
        total: 0,
        page: 1,
        size: 3,
      }
    },
    methods: {
      initNewsList() {
        let url = '/news/list?page=' + this.page + '&size=' + this.size;
        this.getRequest(url).then(resp => {
          if (resp) {
            if(resp.data.length > 0){
              var _this = this;
              this.newsList = resp.data;
              this.newsList.forEach(row => {
                var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.newsPicId;
                row.imgUrl = imgUrl;
              })
              this.total = resp.total;
            }
          }
        });
      },
      sizeChange(currentSize) {
        this.size = currentSize;
        this.initNewsList();
      },
      currentChange(currentPage) {
        this.page = currentPage;
        this.initNewsList();
      }
    },
    mounted() {
      this.initNewsList();
    },
    watch:{
      total(){
        if(this.total==(this.page-1)*this.size && this.total!=0){
          this.page-=1;
          this.initNewsList();//获取列表数据
        }
      }
    },
  }
</script>

<style src="../../assets/css/news.css" scoped>

</style>
